export default __webpack_public_path__ + "static/ai_feedback-592dc4e52e04bfceff87d4d0d6555dd4.mp4";